import type { IconSvgObject } from './types';

const MirrorRoundIcon: IconSvgObject = [
  ["path", { d: "M13.4922 7L6.99219 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.49219 6.5L6.49219 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "11.9922", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default MirrorRoundIcon;
